import getDefaultState from './get-default-state';
import {
  get,
} from '@/utils/lodash';

export default {
  setUser(state, user) {
    state.user = user;
    state.isLoggedIn = true;
    localStorage.token = user != null ? user.token : null;
    sessionStorage.token = user != null ? user.token : null;
    if (user && user.email) {
      const userKey = `newsletter_${user.email}`;
      const newsletterPreference = localStorage.getItem(userKey);
  
      // Add the newsletter preference to the user object
      state.user.newsletter = newsletterPreference === "true"; // Convert to boolean
    }
  },

  createTempUser(state, {
    id,
    email,
  }) {
    if (get(state, 'user.id') == null) {
      state.user = {
        tempUser: {
          id,
          email,
        },
      };
    }
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },

  setUserDetails(state, userDetails) {
    state.userDetails = userDetails;
  },

};
